import { render, staticRenderFns } from "./QuizSelect.vue?vue&type=template&id=a48cea98&"
import script from "./QuizSelect.vue?vue&type=script&lang=js&"
export * from "./QuizSelect.vue?vue&type=script&lang=js&"
import style0 from "./QuizSelect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports